/**
 * The « Tâches » entry of the sidebar and its page (components/tasks): a
 * checklist — a sheet with two ticked lines.
 *
 * Drawn inline like the other icons of this folder (ghostIcon.tsx,
 * terminalIcons.tsx): a 24x24 viewBox, 1em, decorative. Unlike them it is
 * drawn in `currentColor`, in strokes: it sits among the Material UI line
 * icons of the sidebar, which take the item's colour — its ink at rest, the
 * accent once the page is the one on screen. `className` for a place that
 * sizes and colours it, as `IconLabel` does its icons (the « Tâches » tab of
 * « Créer », components/createPage).
 */
export function TasksIcon(props: { className?: string }) {
  return (
    <svg
      className={props.className}
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* The sheet. */}
      <rect x="4" y="3.5" width="16" height="17" rx="2.5" />
      {/* Two ticks, each followed by its line. */}
      <path d="M7.5 9l1.5 1.5 2.5-2.5" />
      <path d="M13.5 9.5h3" />
      <path d="M7.5 15l1.5 1.5 2.5-2.5" />
      <path d="M13.5 15.5h3" />
    </svg>
  );
}
